import React from 'react';
import { isNil, mergeAll } from 'ramda';
import { connect } from 'react-redux';
import { Dialog } from 'react-toolbox/lib/dialog';
import {
  hideDiscardNewModuleConfirmationDialog,
  newModule,
  selectModule,
} from 'manage-modules/redux/manageModulesActions';
import theme from 'manage-modules/components/dialog/DiscardNewModuleConfirmationDialogTheme.css';

const DiscardNewModuleConfirmationDialog = ({
  active,
  onCancel,
  onDiscard,
  selectedItemIds,
}) =>
  <Dialog
    theme={theme}
    active={active}
    title="Are you sure?"
    onEscKeyDown={onCancel}
    onOverlayClick={onCancel}
    actions={[
      { label: 'Cancel', onClick: onCancel },
      { label: 'Discard', onClick: onDiscard },
    ]}
  >
    <p>Discard this new module?</p>
  </Dialog>;

const mapStateToProps = state => {
  const { moduleCard, modulesDrawer } = state.manageModules;

  return {
    selectedModuleId: modulesDrawer.selectedModuleId,
    active: moduleCard.discardNewModuleConfirmationDialog.active,
  };
};

const mapDispatchToProps = dispatch => ({
  onCancel: () => dispatch(hideDiscardNewModuleConfirmationDialog()),
  onDiscard: selectedModuleId => {
    dispatch(hideDiscardNewModuleConfirmationDialog());

    if (!isNil(selectedModuleId)) {
      dispatch(selectModule(selectedModuleId));
    } else {
      dispatch(newModule());
    }
  },
});

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  mergeAll([
    stateProps,
    dispatchProps,
    {
      onDiscard: () => dispatchProps.onDiscard(stateProps.selectedModuleId),
    },
  ]);

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(
  DiscardNewModuleConfirmationDialog,
);
